import { useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import { faqItems } from "@/mocks/faq";

export default function FaqPage() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <Layout>
      <section className="bg-background-950 py-12 md:py-16">
        <div className="container-site">
          <nav className="flex flex-wrap items-center gap-1 text-xs text-background-300" aria-label="面包屑">
            <Link to="/" className="hover:text-background-50">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-background-100">常见问题</span>
          </nav>
          <h1 className="mt-4 font-heading text-2xl font-bold text-background-50 md:text-3xl">
            常见问题
          </h1>
          <p className="mt-3 max-w-2xl text-sm leading-6 text-background-200 md:text-base">
            关于合集、索引与归档的使用方式，以及资源整理、收藏与版权相关的常见问题解答。
          </p>
        </div>
      </section>

      <section className="bg-background-50">
        <div className="container-site py-12 md:py-16">
          <div className="max-w-3xl">
            <div className="space-y-4">
              {faqItems.map((item, idx) => {
                const open = openIdx === idx;
                return (
                  <div
                    key={idx}
                    className="overflow-hidden rounded-lg border border-background-200/70 bg-background-100/60"
                  >
                    <button
                      type="button"
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                      onClick={() => setOpenIdx(open ? -1 : idx)}
                      aria-expanded={open}
                    >
                      <span className="flex items-center gap-3 font-heading text-sm font-semibold text-foreground-900 md:text-base">
                        <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-100 text-xs text-primary-800">
                          Q
                        </span>
                        {item.q}
                      </span>
                      <i
                        className={`ri-add-line shrink-0 text-xl text-foreground-500 transition-transform ${
                          open ? "rotate-45" : ""
                        }`}
                      ></i>
                    </button>
                    {open && (
                      <p className="border-t border-background-200/70 bg-background-50 px-5 py-4 text-sm leading-6 text-foreground-600">
                        {item.a}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>

            <div className="mt-10 rounded-lg border border-primary-200 bg-primary-50/70 p-6">
              <h2 className="flex items-center gap-2 text-sm font-semibold text-primary-900">
                <i className="ri-question-line"></i>
                没有找到你想问的？
              </h2>
              <p className="mt-2 text-sm leading-6 text-foreground-700">
                欢迎通过邮件联系我们，或前往「关于我们」页获取投稿与建议的方式，我们会尽快回复。
              </p>
              <Link to="/about" className="btn-primary mt-4">
                联系我们
              </Link>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}